<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增标签</Button>				
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="标签名称" prop="tagName">
					<Input v-model="addForm.tagName" maxlength="100" placeholder="请输入标签名称" clearable></Input>
				</FormItem>		
				<FormItem label="类型" prop="type">
					<RadioGroup v-model="addForm.type">
						<Radio label="1">支出</Radio>
						<Radio label="2">收入</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="图标" prop="tagIcon">
					<Upload :action="uploadFile" name="file" :on-success="logoImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图标</Button>
					</Upload>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>


	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				
				addForm: {
					id: undefined,
					tagName: '',
					tagIcon: '',
					type: '',					
				},
				addRule: {
					tagName: [{
						required: true,
						message: '请填写标签名称',
						trigger: 'blur',
					}],
					type: [{
						required: true,
						message: '请选择分类',
						trigger: 'blur'
					}],
					tagIcon: [{
						required: true,
						message: '请上传图标',
						trigger: 'blur'
					}, ],
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: 'ID',
						width: 160,
						key: 'id',
						align: 'center'
					},
					{
						title: '名称',
						width: 350,
						key: 'tagName',
						align: 'center'
					},
					{
						title: '类型',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.type;
							if (val == 1) {
								name = '支出'
							} else {
								name = '收入'
							}
							return h('span', name)
						}
					},{
						title: '图标',
						width: 350,
						key: 'tagIcon',
						align: 'center'
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			},

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.bookTagePage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addSchoolJobShow() {
				this.addForm ={
					id: undefined,
					tagName: '',
					tagIcon: '',
					type: '',					
				},
				this.addJobShow = true
			},
			logoImgBack(response, file, fileList) {
				this.addForm.tagIcon = response.data.url
			},
			
			addOrEditData(row) {
				const that = this
				let addData = {
					...that.addForm
				}
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.addOrEditTag(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
			
			editData(data) {
				this.addForm = data
				this.addJobShow = true
			},
		
		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>